var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/auth/ForgotPassword/index.tsx";
import React, { useCallback, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { ApiStatus } from 'Enums';
import { useApiError, usePartner } from 'Hooks';
import Wizard from 'Components/wizard';
import WizardMainContainer from 'Components/wizard/WizardMainContainer';
import { setUrls } from 'Utilities/dataHelpers';
import { forgotPass } from 'Services/auth';
import ForgotPassFirstStep from './steps/ForgotPassFirstStep';
import ForgotPassSecondStep from './steps/ForgotPassSecondStep';
const mapStateToProps = ({
  env: {
    app,
    redirect_uri,
    pId
  },
  config
}) => {
  return {
    app,
    redirect_uri,
    pId,
    config
  };
};
const connector = connect(mapStateToProps);
const ForgotPasswordPage = ({
  app,
  pId,
  config
}) => {
  const [loading, setLoading] = useState(false);
  const [initialValues] = useState({
    email: ''
  });
  const {
    showApiErrorModal
  } = useApiError();
  const {
    showHcpError,
    showForgotPasswordBlockedMessage,
    showForgotPasswordConfirmatioMessage,
    showCountryRegionError,
    handleForgotPasswordDone
  } = usePartner();
  const handleWrongRegionError = useCallback((error, handleSubmit) => {
    const unsupportedCountry = error.response?.data.errors[0]?.unsupportedCountry;
    if (!unsupportedCountry) {
      showApiErrorModal();
      return;
    }
    setUrls(config, unsupportedCountry);
    handleSubmit();
  }, [config, showApiErrorModal]);
  const handleApiRequestError = useCallback((error, handleSubmit) => {
    switch (error.status) {
      case ApiStatus.FORBIDDEN:
        {
          const code = error.response?.data.code;
          if (code === ApiStatus.FORBIDDEN_HCP_ACCOUNT) {
            showHcpError();
          }
          break;
        }
      case ApiStatus.BAD_REQUEST:
        {
          const code = error.response?.data.code;
          if (code === ApiStatus.UNSUPPORTED_COUNTRY) {
            showCountryRegionError();
            return;
          }
          if (code === ApiStatus.WRONG_REGION) {
            handleWrongRegionError(error, handleSubmit);
            return;
          }
          showApiErrorModal();
          break;
        }
      case ApiStatus.TOO_MANY_REQUESTS:
        showForgotPasswordBlockedMessage();
        break;
      default:
        showApiErrorModal();
    }
  }, [handleWrongRegionError, showApiErrorModal, showCountryRegionError, showForgotPasswordBlockedMessage, showHcpError]);
  const handleSubmitForgotPass = useCallback((email, submitForm) => {
    return new Promise((resolve, reject) => {
      setLoading(true);
      forgotPass(email, app, pId).then(resolve).catch(error => {
        handleApiRequestError(error, submitForm);
        reject(error);
      }).finally(() => {
        setLoading(false);
      });
    });
  }, [app, handleApiRequestError, pId]);
  const makeSteps = useMemo(() => {
    return [{
      component: ForgotPassFirstStep,
      componentName: 'ForgotPassFirstStep'
    }, {
      component: ForgotPassSecondStep,
      componentName: 'ForgotPassSecondStep'
    }];
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 145,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(WizardMainContainer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 146,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Wizard, {
    steps: makeSteps,
    initialValues: initialValues,
    handleSubmitForgotPass: handleSubmitForgotPass,
    handleOnDoneClick: handleForgotPasswordDone,
    showForgotPasswordConfirmatioMessage: showForgotPasswordConfirmatioMessage,
    loading: loading,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 147,
      columnNumber: 9
    }
  })));
};
export default connector(ForgotPasswordPage);